import * as React from "react";
import { MapPin, Phone, Smartphone, Map } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const locations = [{
  id: 1,
  name: "Durango Clinical Space",
  address: "TBD",
  phone: "(970) 279-3344",
  whatsapp: "(970) 279-3344",
  mapUrl: "https://maps.google.com/?q=Durango,+Colorado",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1639921/img/map_location_interlagos.png"
}, {
  id: 2,
  name: "In-Home Care Range",
  address: "Traveling within a 20-minute radius of Durango for mobile appointments",
  phone: "(970) 279-3344",
  whatsapp: "(970) 279-3344",
  mapUrl: "https://maps.google.com/?q=Durango,+Colorado",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1639921/img/map_location_franco_da_rocha.png"
}, {
  id: 3,
  name: "Trail-Side Recovery",
  address: "Convenient meeting points near major Durango trailheads and parks",
  phone: "(970) 279-3344",
  whatsapp: "(970) 279-3344",
  mapUrl: "https://maps.google.com/?q=Durango,+Colorado",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1639921/img/map_location_perdizes.png"
}];
export default function OurStores() {
  return <section data-section-id="224972" id="where-we-meet" className="w-full dark bg-background py-24 text-foreground">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-16">
          <span className="font-default text-destructive text-sm font-bold uppercase tracking-wider mb-2 block">
            Location & Service Areas
          </span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {locations.map((loc, i) => <Card key={loc.id} data-index={i} className="rounded-sm shadow-lg border-l-4 border-primary overflow-hidden flex flex-col h-full bg-card">
              <div className="h-48 w-full relative bg-muted grayscale opacity-80 hover:grayscale-0 transition-all duration-500">
                <img src={loc.image} alt={`Map location for ${loc.name}`} className="w-full h-full object-cover" />
              </div>
              <CardHeader className="px-6 pt-6 pb-4">
                <CardTitle className="text-2xl font-default text-foreground">
                  {loc.name}
                </CardTitle>
              </CardHeader>
              <CardContent className="px-6 pb-6 flex-grow flex flex-col gap-4">
                <div className="flex items-start gap-3">
                  <MapPin className="w-5 h-5 text-primary shrink-0 mt-0.5" />
                  <span className="text-muted-foreground font-default text-sm leading-relaxed">
                    {loc.address}
                  </span>
                </div>
                <div className="flex items-center gap-3">
                  <Phone className="w-5 h-5 text-primary shrink-0" />
                  <span className="text-muted-foreground font-default text-sm">
                    {loc.phone}
                  </span>
                </div>
                <div className="flex items-center gap-3">
                  <Smartphone className="w-5 h-5 text-primary shrink-0" />
                  <span className="text-muted-foreground font-default text-sm">
                    {loc.whatsapp}
                  </span>
                </div>
              </CardContent>
              <CardFooter className="px-6 pb-6 pt-0 mt-auto">
                <Button asChild variant="destructive" className="w-full rounded-none font-default uppercase tracking-wider hover:bg-destructive/90 transition-colors">
                  <Link to={loc.mapUrl} newTab>
                    <Map className="w-4 h-4 mr-2" />
                    Get Directions
                  </Link>
                </Button>
              </CardFooter>
            </Card>)}
        </div>
      </div>
    </section>;
}